import { FC } from 'react';
import { styled } from 'styled-components';

interface IGetHistoryButtonProps {
  onClick?: () => void;
}

const GetHistoryButtonWrap = styled.button`
  font-size: 12rem;
  color: #0054fc;
  background-color: #e9edf6;
  border-radius: 90rem;
  height: 25rem;
  padding: 0 8rem;
  margin: 0 auto;
`;

const GetHistoryButton: FC<IGetHistoryButtonProps> = (props) => {
  return (
    <GetHistoryButtonWrap onClick={() => props.onClick?.()}>查看历史消息</GetHistoryButtonWrap>
  );
};

export default GetHistoryButton;
